import { render, staticRenderFns } from "./CheckCompanyColleagueProp.vue?vue&type=template&id=3a1caf75&scoped=true"
import script from "./CheckCompanyColleagueProp.vue?vue&type=script&lang=js"
export * from "./CheckCompanyColleagueProp.vue?vue&type=script&lang=js"
import style0 from "./CheckCompanyColleagueProp.vue?vue&type=style&index=0&id=3a1caf75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1caf75",
  null
  
)

export default component.exports